var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiCallIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1866 21.5436C26.6513 22.0051 28.0413 22.7626 29.3783 23.7258C29.835 24.0548 30.0667 24.6157 29.9832 25.1723C29.834 26.1665 29.6526 27.1236 29.432 28.0366C29.1348 29.2666 27.9897 30.0978 26.7289 29.9907C22.8899 29.6648 18.8151 27.7899 15.5126 24.4874C12.2101 21.1849 10.3352 17.1101 10.0093 13.2711C9.90222 12.0103 10.7334 10.8652 11.9634 10.568C12.8764 10.3474 13.8335 10.166 14.8277 10.0168C15.3843 9.9333 15.9452 10.165 16.2742 10.6217C17.2373 11.9587 17.9949 13.3487 18.4563 14.8134C18.6537 15.4399 18.4236 16.1226 17.8853 16.4992L15.8634 17.9136C16.634 19.1207 17.5598 20.2829 18.6384 21.3616C19.7171 22.4402 20.8793 23.366 22.0864 24.1366L23.5008 22.1147C23.8774 21.5764 24.5601 21.3463 25.1866 21.5436Z",
    fill: "url(#paint0_linear_5692_3478)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 39C9.52344 39 1 30.4766 1 20C1 9.52344 9.52344 1 20 1C30.4766 1 39 9.52344 39 20C39 30.4766 30.4766 39 20 39ZM20 3C10.6262 3 3 10.6262 3 20C3 29.3738 10.6262 37 20 37C29.3738 37 37 29.3738 37 20C37 10.6262 29.3738 3 20 3Z",
    fill: "url(#paint1_linear_5692_3478)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5692_3478",
    x1: 20,
    y1: 10,
    x2: 20,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3C3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5692_3478",
    x1: 20,
    y1: 1,
    x2: 20,
    y2: 39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3C3C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiCallIcon);
export default __webpack_public_path__ + "static/media/fi-call-icon.a1597b77cc75657e2c40cdf660a0275e.svg";
export { ForwardRef as ReactComponent };